import React from 'react';
import { getGlobal } from 'reactn';
import DownloadIcon from '../assets/download-icon-blue.svg';

const NeedHelp = ({ className, ...rest }) => {
  const { siteDetails } = getGlobal('siteDetails');
  return (
    <div className={`flex flex-col justify-end ${className}`} {...rest}>
      <div className="flex flex-row justify-start items-center">
        <a href={siteDetails.mcwa_need_help_url} target="_blank" rel="noopener noreferrer">
          <img
            className="w-8"
            src={DownloadIcon}
            alt="download_icon"
          />
        </a>
        <div className="ml-4">
          <p className="text-base font-bold text-blue-dark" style={{ color: '#2A4E68' }}>
            Need Help?
          </p>
          <a
            href={siteDetails.mcwa_need_help_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm"
          >
            Download our Water Bill How-to-Guide
          </a>
        </div>
      </div>
    </div>
  );
};

export default NeedHelp;
